import React from "react";
import { motion } from "framer-motion";

const CONFETTI_COLORS = ["#39ff14", "#ffd700", "#a855f7", "#f5f0e6", "#cd7f32", "#ff2e63"];

// One-shot celebratory burst. Remount (via `key`) to replay.
export default function Confetti({ count = 18, spread = 130, className = "left-1/2 top-6 -translate-x-1/2" }) {
  const pieces = React.useMemo(() => Array.from({ length: count }).map((_, i) => {
    const angle = (Math.PI * 2 * i) / count + (Math.random() - 0.5) * 0.4;
    const dist = spread * 0.45 + Math.random() * spread * 0.55;
    return {
      id: i,
      x: Math.cos(angle) * dist,
      y: Math.sin(angle) * dist - 25,
      rot: (Math.random() - 0.5) * 540,
      color: CONFETTI_COLORS[i % CONFETTI_COLORS.length],
      delay: Math.random() * 0.15,
      w: Math.random() > 0.5 ? "w-1.5 h-2.5" : "w-2 h-2",
    };
  }), [count, spread]);

  return (
    <div className={`pointer-events-none absolute z-20 ${className}`} aria-hidden="true" data-testid="confetti-burst">
      {pieces.map((p) => (
        <motion.span key={p.id}
          initial={{ opacity: 1, x: 0, y: 0, scale: 1, rotate: 0 }}
          animate={{ opacity: 0, x: p.x, y: p.y, scale: 0.5, rotate: p.rot }}
          transition={{ duration: 1.3, delay: p.delay, ease: "easeOut" }}
          className={`absolute block ${p.w}`}
          style={{ backgroundColor: p.color }}
        />
      ))}
    </div>
  );
}
